import { Info } from '@mui/icons-material';
import {
    Box,
    Stack,
    ToggleButton,
    ToggleButtonGroup,
    Tooltip,
    Typography,
} from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useRecoilState } from 'recoil';
import { lineOptionsState } from '~/state/atoms/toolsAtoms';

export default function LineDrawTool() {
    const [lineOptions, setLineOptions] = useRecoilState(lineOptionsState);

    const handleModeToggle = (
        _: React.MouseEvent<HTMLElement, MouseEvent>,
        newMode: 'draw' | 'erase' | null
    ) => {
        if (newMode !== null && newMode !== lineOptions.mode) {
            setLineOptions((options) => ({
                ...options,
                mode: options.mode === newMode ? null : newMode,
            }));
        }
    };

    const guideMessage = <FormattedMessage id="lineToolGuide" />;

    return (
        <Box display="flex" flexDirection="column" gap={1}>
            <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="h6">
                    <FormattedMessage id="lineTool" />
                </Typography>
                <Tooltip title={guideMessage}>
                    <Info fontSize="small" />
                </Tooltip>
            </Stack>
            <ToggleButtonGroup
                color="primary"
                value={lineOptions.mode}
                exclusive
                onChange={handleModeToggle}
                aria-label="Draw or Erase Mode"
                fullWidth
                size="small"
            >
                <ToggleButton value="draw">Draw</ToggleButton>
                <ToggleButton value="erase">Erase</ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
}
